export default object => ({
  id: object.id ?? 0,
  processeId: object.processeId ?? 0,
  text: object.text ?? '',

  number: object.number ?? 0,
  year: object.year ?? 0,
  typeName: object.typeName ?? '',
});
